import { TInitStore } from '@monorepo/types';
import produce from 'immer';
import { INITIAL_CACHE_RESET_TIMESTAMP } from '../metadata/metadata.reducer';
import { InitStoreActionTypes, TInitStoreActions } from './init-db.actions';

export function getInitStoreInitalState(nextCacheResetTimestamp: number) {
  const initStoreInitalState: TInitStore = {
    lockDetails: {
      isLocked: false,
      lockedBy: 'NONE',
    },
    nextCacheResetTimestampDB: {
      nextCacheResetTimestamp: nextCacheResetTimestamp,
    },
  };
  return initStoreInitalState;
}
export const initStoreInitalState: TInitStore = getInitStoreInitalState(INITIAL_CACHE_RESET_TIMESTAMP);

export function InitStoreStateReducer(state: TInitStore = initStoreInitalState, action: TInitStoreActions): TInitStore {
  switch (action.type) {
    case InitStoreActionTypes.UpdateInitStoreLockDetails: {
      return produce(state, (draft) => {
        draft.lockDetails = action.lockDetails;
      });
    }
    case InitStoreActionTypes.UpdateNextCacheResetTimestampDBAndReleaseLock: {
      return produce(state, (draft) => {
        draft.nextCacheResetTimestampDB = action.nextCacheResetTimeStampDB;
        draft.lockDetails = {
          isLocked: false,
          lockedBy: 'NONE',
        };
      });
    }
    default:
      return state;
  }
}
